<template>
  <Page>
    <template #deck>
      <div v-html="rootCategory.descriptionHtml" />
    </template>

    <div v-if="categories">
      <div
        v-for="category in categories"
        class="mb-12 lg:mb-24"
      >
        <h3 class="mb-8 text-lg font-bold">
          <nuxt-link :to="'/shop/' + category.handle">{{
            collection.title
          }}</nuxt-link>
        </h3>
        <CollectionGrid
          :path-root="'/shop/' + category.handle"
          :collections="category.subcollections.references.nodes"
        />
      </div>
    </div>

    <div v-else>
      No shop categories found
    </div>
  </Page>
</template>

<script setup>
const route = useRoute()
const query = gql`
query ($handle: String) {
    collection(handle: $handle) {
      id
      title
      description
      descriptionHtml
      seo {
        title
        description
      }
      subcollections: metafield(
        namespace: "custom"
        key: "subcollections"
      ) {
        references(first: 30) {
          nodes {
            ... on Collection {
              id
              handle
              title
              subcollections: metafield(
                key: "subcollections"
                namespace: "custom"
              ) {
                references(first: 6) {
                  nodes {
                    ... on Collection {
                      id
                      title
                      handle
                      image {
                        url
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`

const variables = { handle: "categories" }
const { data } = await useAsyncQuery(
  "categories",
  { query, variables },
)

const rootCategory = computed(
  () => data?.value?.collection ?? null,
)

if (!rootCategory.value) throw createError({ statusCode: 404, statusMessage: "Page Not Found" })

// // Computed
const categories = computed(
  () => rootCategory?.value?.subcollections?.references?.nodes ?? null,
)

route.meta.title = rootCategory?.value?.title || ""
route.matched[route.matched.length - 1].meta.title = rootCategory?.value?.title || ""

useSeoMeta({
  title: () => rootCategory?.value?.seo.title || rootCategory?.value?.title || "",
  description: () => rootCategory?.value?.seo.description || rootCategory?.value?.description || "",
})
</script>
